import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Components
import { Container } from "./Container";
import { Header } from "./Header";
import { Main } from "./Main";
import PortalLayout from "./PortalLayout/PortalLayout";
import { getAccessTokenSilently, getAuthenticated } from "utils/functions";

export const AppLayout = ({ children, isDonationLayout, ...rest }) => {
  // Re-evaluate auth on every route change so login → redirect works without refresh
  useLocation();

  useEffect(() => {
    (async () => {
      const token = await getAccessTokenSilently();
      localStorage.removeItem("externalToken");
      localStorage.setItem("token", token);
    })();
  }, []);

  const isAuthenticated = getAuthenticated();

  // Authenticated portal members always get PortalLayout — must come first
  // so that leftover redirectUrl from external school/event flows doesn't
  // accidentally serve the old Container layout on first portal visit.
  if (isAuthenticated) {
    return <PortalLayout>{children}</PortalLayout>;
  }

  // Unauthenticated users coming from external school/event/donation flows
  if (
    (localStorage.getItem("DonationLayout") &&
      localStorage.getItem("DonationLayout") === true) ||
    (localStorage.getItem("redirectUrl") &&
      localStorage.getItem("redirectUrl") !== "/donation-view")
  ) {
    return (
      <Container {...rest}>
        <>{children}</>
      </Container>
    );
  }

  return (
    <Container {...rest}>
      <Header />
      <Main>{children}</Main>
    </Container>
  );
};
